/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {updateTile} from '../api'

export const useMutationUpdateTile = createReactQueryMutationHook('updateTile', updateTile)
